/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Category_DeliveryInputs */

const en_tasks_category_delivery = /** @type {(inputs: Tasks_Category_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery`)
};

const fr_tasks_category_delivery = /** @type {(inputs: Tasks_Category_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison`)
};

const ms_sg2_tasks_category_delivery = /** @type {(inputs: Tasks_Category_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghantaran`)
};

/**
* | output |
* | --- |
* | "Delivery" |
*
* @param {Tasks_Category_DeliveryInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_category_delivery = /** @type {((inputs?: Tasks_Category_DeliveryInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Category_DeliveryInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_category_delivery(inputs)
	if (locale === "fr") return fr_tasks_category_delivery(inputs)
	return ms_sg2_tasks_category_delivery(inputs)
});